<template>
  <Teleport to="body">
    <div v-if="loading.active" class="spinner-overlay" role="status" aria-live="polite">
      <ProgressSpinner :style="{ width: size, height: size }" aria-hidden="true" />
      <span class="sr-only">{{ loading.label }}</span>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import ProgressSpinner from "primevue/progressspinner";
import { useLoading } from "@/core/services/loading/loading.service";

interface Props {
  size?: string;
  strokeWidth?: number;
  animationDuration?: string;
  showLabel?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: "50px",
  strokeWidth: 5,
  animationDuration: "0.5s",
  showLabel: false,
});

const { state: loading } = useLoading();
const { size } = props;
</script>

<style scoped>
.spinner-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;

  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: center;
  align-items: center;

  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(2px);

  animation: spinner-fade 0.15s ease-out;
}

.spinner-inline {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  animation: spinner-fade 0.15s ease-out;
}

.spinner-label {
  font-weight: 600;
}

@keyframes spinner-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner-overlay,
  .spinner-inline {
    animation: none;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
